module.exports = __webpack_public_path__ + "img/pen-info-2.351a7439.png";